import { getPublicRuntimeConfig } from "../../utils/runtime-config";
/**
 * Configuration utilities
 */
/**
 * Get DTN_PRODUCT_CODE from runtime environment (window.__ENV__ on client, process.env on server)
 */
export const getProductCode = () => {
    const { DTN_PRODUCT_CODE } = getPublicRuntimeConfig();
    return DTN_PRODUCT_CODE;
};
